import {action, makeObservable, observable, runInAction} from "mobx";

import {AdminApi} from "../../../api/api";
import {CategoryGroupDetailOutput} from "../../../api/values/category-group-detail-output";
import {Stores} from "../../../stores";
import {Permission} from "../../../stores/authentication-store";
import {buildDeleteMessage} from "../../../utils/delete-message";
import {PageStoreConstructorOptions} from "../../../utils/page-store";
import {PageRouter} from "../../../utils/route-util";
import {deleteDialogStore} from "../../organisms/delete-dialog/delete-dialog-store";

export class CategoryGroupDetailPageStore {
    @observable
    public mediaId: string = "";
    @observable
    public categoryGroupId: string = "";
    @observable
    public categoryGroup: CategoryGroupDetailOutput = new CategoryGroupDetailOutput();
    private adminApi: AdminApi;
    private stores: Stores;
    private pageRouter: PageRouter;
    constructor(options: PageStoreConstructorOptions) {
        makeObservable(this);
        this.pageRouter = options.pageRouter;
        this.adminApi = options.adminApi;
        this.stores = options.stores;
    }

    public async initialize({query}: {query: {mediaId: string; categoryGroupId: string}}) {
        this.stores.authenticationStore.checkAnyPermissionExists(
            Permission.MANAGE_SYSTEM,
            Permission.MANAGE_MEDIA,
        );
        this.setMediaId(query.mediaId || "");
        this.setCategoryGroupId(query.categoryGroupId || "");
        await this.load();
    }

    @observable
    public setMediaId(mediaId: string) {
        this.mediaId = mediaId;
    }

    @observable
    public setCategoryGroupId(categoryGroupId: string) {
        this.categoryGroupId = categoryGroupId;
    }

    @action.bound
    public confrmDeleteCategoryGroup() {
        const isUsedDocument = this.categoryGroup.categories.some((x) => x.count! > 0);
        const message = buildDeleteMessage(this.categoryGroup.label, isUsedDocument);
        deleteDialogStore.open(
            "カテゴリグループ削除",
            message,
            async () => await this.deleteCategoryGroup(),
        );
    }
    public async load() {
        try {
            const result = await this.adminApi.getCategoryGroupDetail(
                {
                    mediaId: this.mediaId,
                },
                {
                    categoryGroupId: this.categoryGroupId,
                },
            );
            runInAction(() => {
                this.categoryGroup = result;
            });
        } catch (error) {
            console.error(error);
        }
    }

    public async deleteCategoryGroup() {
        try {
            await this.adminApi.deleteCategoryGroup(
                {
                    mediaId: this.mediaId,
                },
                {
                    categoryGroupId: this.categoryGroupId,
                },
            );
            this.pageRouter.pushRoute(`/admin/${this.mediaId}/category-groups`);
        } catch (error) {
            console.error(error);
        }
    }
}
